module.exports = __webpack_public_path__ + "static/media/emj19.49a0637d.svg";